import {
  IMAGE_FILE_OPTIMIZATION_PATTERN,
  IMAGE_FILE_OPTIMIZED_EXTENSION
} from './constants'

export const getOptimizedImageExtension = (url: string) =>
  url?.replace(IMAGE_FILE_OPTIMIZATION_PATTERN, IMAGE_FILE_OPTIMIZED_EXTENSION)
